import clsx from 'clsx';
import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import Transition, { ENTERED, ENTERING } from 'react-transition-group/Transition';
import { jsx as _jsx } from "react/jsx-runtime";
const fadeStyles = {
  [ENTERING]: 'in',
  [ENTERED]: 'in'
};
function Fade(_ref) {
  let {
    className,
    children,
    nodeRef: nodeRefProp,
    in: inProp = false,
    timeout = 300,
    mountOnEnter = false,
    unmountOnExit = false,
    appear = false,
    ...props
  } = _ref;
  // Always use a ref - create one if not provided
  const defaultNodeRef = useRef(null);
  const nodeRef = nodeRefProp || defaultNodeRef;
  return /*#__PURE__*/_jsx(Transition, {
    in: inProp,
    timeout: timeout,
    mountOnEnter: mountOnEnter,
    unmountOnExit: unmountOnExit,
    appear: appear,
    nodeRef: nodeRef,
    ...props,
    children: (status, innerProps) => /*#__PURE__*/React.cloneElement(children, {
      ...innerProps,
      ref: nodeRef,
      className: clsx('fade', className, children.props.className, fadeStyles[status])
    })
  });
}
export default Fade;